const project = {
  signupUrl: 'https://my.simplebackups.com/register',
  loginUrl: 'https://my.simplebackups.com/login',
  supportUrl: 'https://support.simplebackups.com/en/',
}

export default project;